var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("booking-menu-with-budget-header", {
        attrs: { title: _vm.$t("booking.rail.title") }
      }),
      _c("v-row"),
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { md: "3", sm: "5", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: _vm.$t("global.search"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("booking-rail-data-table", { attrs: { search: _vm.search } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }